export default __webpack_public_path__ + "static/media/femaleApes.08173667.jpeg";